<template>
    <v-app id="app">
        <!-- App bar -->
        <v-app-bar app clipped-right color="bal-gray" light flat>
            <v-app-bar-nav-icon large @click.stop="toggleDrawer"/>
            <v-toolbar-title
            >{{
                    `${ $route.meta.title }` | t
                }}<span style="color:gray;">{{ ` (${ tagCount })` }}</span></v-toolbar-title
            >
            <v-combobox
                    v-if="hasPermissionForAction(PermissionsConstants.TAG, PermissionsConstants.SEARCH)"
                    :items="searchHistory"
                    :value="searchTagString"
                    @input="controlSearchString($event)"
                    item-text="keyword"
                    id="searchInput"
                    class="mt-6 mx-2"
                    :placeholder="t('Tag name, description')"
                    prepend-inner-icon="search"
                    clearable
                    flat
                    solo
                    dense
            >
                <template slot="item" slot-scope="data">
                    <span
                            @click="updateTagSearchOnClick(data.item.keyword)"
                            style="width: 100%; height: 100%"
                            class="pa-2"
                    >{{ data.item.keyword }}</span
                    >
                </template>
            </v-combobox>
            <v-spacer v-else/>
            <v-btn
                    dark
                    color="bal-red"
                    class="px-2 ml-2"
                    style="min-width: 0;"
                    v-if="hasPermissionForAction(PermissionsConstants.TAG, PermissionsConstants.CREATE)"
                    @click.stop="openNewTagDrawer"
            >
                <v-icon>add</v-icon>
            </v-btn>
        </v-app-bar>

        <!-- Drawer left -->
        <main-drawer :drawer-open="mainDrawerOpen"/>

        <!--    Right drawer    -->
        <v-navigation-drawer :value="drawerOpen" fixed right hide-overlay width="900">
            <tag-view v-if="$route.name === 'tag-view'"></tag-view>
            <tag-edit v-if="$route.name === 'tag-edit'"></tag-edit>
        </v-navigation-drawer>

        <!-- Main content -->
        <v-main>
            <router-view/>
        </v-main>

        <!-- Footer -->
        <page-footer/>

        <v-snackbar color="success" bottom :timeout="2500" :value="requestSuccess">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">check</v-icon>
                <div class="title pa-2 ">{{ "Success" | t }}</div>
            </div>
        </v-snackbar>

        <v-snackbar color="error" bottom :timeout="2500" :value="requestError">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">check</v-icon>
                <div class="title pa-2 ">{{ errorMessage }}</div>
            </div>
        </v-snackbar>
    </v-app>
</template>
<script>
import MainDrawer from "../components/main-drawer.vue";
import PageFooter from "../components/page-footer.vue";

import TagView from "../pages/tags/tag-view.vue";
import TagEdit from "../pages/tags/tag-edit.vue";

import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { PermissionsConstants } from "@/permissions";

export default {
    components: {
        TagView,
        TagEdit,
        PageFooter,
        MainDrawer
    },
    data() {
        return {
            mainDrawerOpen: null
        };
    },
    async created() {
        await this.getSearchHistory(this.$route.path.replace("/", ""));
    },
    async mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        const drawerState = localStorage.getItem("mainDrawerOpen");
        if (drawerState) {
            this.mainDrawerOpen = JSON.parse(drawerState);
        } else {
            this.mainDrawerOpen = true;
        }
    },
    async destroyed() {
        if (this.searchTagString.length > 0) await this.resetTagSearch();
        document.removeEventListener("keydown", this.handleKeyboardListener);
        await this.setRequestSuccess(false);
        await this.setErrorMessage("");
    },
    methods: {
        ...mapMutations("TagStore", [
            "resetActiveTag",
            "updateTagSearch",
            "setRequestSuccess",
            "setErrorMessage",
            "resetTagSearch"
        ]),
        ...mapActions("SearchHistoryStore", ["getSearchHistory"]),
        ...mapActions("TagStore", ["getTagData"]),
        openNewTagDrawer() {
            return this.$router.push({ name: "tag-edit", params: { tagId: "new" } });
        },
        async updateUserSearch(value) {
            await this.updateTagSearch({ term: value });
            await this.setRequestSuccess(false);
            await this.setErrorMessage("");
        },
        toggleDrawer() {
            this.mainDrawerOpen = !this.mainDrawerOpen;
            localStorage.setItem("mainDrawerOpen", this.mainDrawerOpen);
        },
        async handleKeyboardListener(e) {
            if (e.keyCode === 27 && this.mainDrawerOpen) {
                await this.resetActiveTag();
                return await this.$router.push({ name: "tag-list" });
            } else if (e.keyCode === 13 && document.activeElement.tagName === "INPUT") {
                await this.updateTagSearch({
                    term: document.querySelector("#searchInput").value
                });
            }
            if (
                    this.activeTag &&
                    Object.keys(this.activeTag).length > 0 &&
                    this.activeTag.id !== "new" &&
                    this.$route.name !== "tag-edit"
            ) {
                let currentTagIndex = this.tags.findIndex(
                        p => p.id === this.activeTag.id
                );
                if (e.key === "ArrowUp") {
                    if (currentTagIndex !== 0) {
                        const newTagId = this.tags[currentTagIndex - 1].id;
                        await this.getTagData(newTagId);
                        return await this.$router.push({ name: this.$route.name, params: { tagId: newTagId } });
                    }
                } else if (e.key === "ArrowDown") {
                    if (currentTagIndex + 1 !== this.tags.length) {
                        const newTagId = this.tags[currentTagIndex + 1].id;
                        await this.getTagData(newTagId);
                        return await this.$router.push({ name: this.$route.name, params: { tagId: newTagId } });
                    }
                }
            }
        },
        async updateTagSearchOnClick(value) {
            await this.updateUserSearch({
                term: value
            });
        },
        controlSearchString(value) {
            if (value === "") this.updateUserSearch(value);
        }
    },
    computed: {
        ...mapState("TagStore", [
            "drawerOpen",
            "searchTagString",
            "requestSuccess",
            "tags",
            "activeTag",
            "tagCount",
            "requestError",
            "errorMessage"
        ]),
        ...mapState("SearchHistoryStore", ["searchHistory"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    }
};
</script>

<style scoped>
.v-input__icon--prepend-inner .v-icon {
    margin-top: 0px !important;
}
</style>
